import React from "react";
import Cases from "../../api/cases";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./CasesSection.css";

const CasesSection = (props) => {
    const { hclass, ShowSectionTitle = true, sliceStart = 0, sliceEnd = 12 } = props;
    
    return (
        <section className={hclass}>
            <div className="container">
                {ShowSectionTitle && (
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-12">
                            <SectionTitle
                                title={"Casos de Éxito"}
                                subtitle={
                                    "Conoce algunos de nuestros casos más destacados y los resultados que hemos logrado para nuestros pacientes."
                                }
                            />
                        </div>
                    </div>
                )}
                <div className="cases_wrapper">
                    {Cases.slice(sliceStart, sliceEnd).map((caseItem, index) => {
                        const imageCount = caseItem.images.length;
                        
                        return (
                            <div className="case_container" key={caseItem.id}>
                                <div className="case_card">
                                    <div className="case_header">
                                        <h3>{caseItem.title}</h3>
                                    </div>
                                    <div className="case_images">
                                        {caseItem.images.map((image, imgIndex) => (
                                            <div 
                                                key={imgIndex} 
                                                className={`case_image ${imageCount === 1 ? 'single' : imageCount === 2 ? 'double' : 'triple'}`}
                                            >
                                                <img src={image} alt={`${caseItem.title} - Imagen ${imgIndex + 1}`} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default CasesSection;
